import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./Tier.module.scss";
export const Tier = ({ name, description, asset, id, altText }) => {
    return (_jsx("div", { className: classNames(styles.tier, "tierItem"), "data-tierid": id, children: _jsxs("div", { className: styles.wrapper, children: [_jsx("div", { className: styles.name, children: name }), _jsx("div", { className: styles.description, children: description }), _jsx("img", { alt: altText, className: styles.image, src: asset })] }) }));
};
//# sourceMappingURL=Tier.js.map